import React, { Fragment } from "react"
import { css } from "react-emotion"
import { withRouter } from "react-router"

import Studio from "features/studio/Studio"
import WithObject from "data/wrappers/WithObject"

import {
    Breadcrumbs,
    PageTitle,
    Button,
    Section,
    Card,
    SectionHeader,
    ButtonModal,
    Container,
    Text,
} from "ui"
import AttributeList from "features/records/components/AttributeList"

import FieldTable from "features/studio/components/FieldTable"
import NewFieldButton from "features/studio/components/NewFieldButton"

class ObjectDetailPage extends React.Component {
    getCrumbs = objectName => [
        { label: "Data", link: "/data" },
        { label: "Tables", link: "/tables" },
    ]

    render() {
        return (
            <Studio>
                <WithObject objectId={this.props.params.objectId}>
                    {({ object, onChange, createField }) => {
                        const crumbs = this.getCrumbs(object.name)
                        const buttons = [
                            <Button
                                onClick={() =>
                                    this.props.router.push(`/table/${object._sid}/records`)
                                }
                                key="rev"
                                name={object.name}
                                sideMargin="small"
                                margin={"small"}
                                size="small"
                            >
                                View Records
                            </Button>,
                            //<DeleteObjectButton key="delete" name={object.name} />,
                        ]
                        return (
                            <Fragment>
                                <HeaderBar label={object.name} crumbs={crumbs} buttons={buttons} />
                                <Section margin="none" padding="none">
                                    <SectionHeader>Details</SectionHeader>
                                    <Card>
                                        <Container wrapItems>
                                            <AttributeList
                                                editable
                                                data={object}
                                                onChange={data => onChange(object._sid, data)}
                                                fields={[{ api_name: "name", label: "Name" }]}
                                            />
                                        </Container>
                                    </Card>
                                </Section>
                                <Section padding="none">
                                    <SectionHeaderWithButtons create={createField}>
                                        Fields
                                    </SectionHeaderWithButtons>
                                    <FieldTable data={object.fields} />
                                </Section>
                            </Fragment>
                        )
                    }}
                </WithObject>
            </Studio>
        )
    }
}

export default withRouter(ObjectDetailPage)

const SectionHeaderWithButtons = props => (
    <SectionHeader>
        <Container spaced>
            <span style={{ alignSelf: "flex-end" }}>{props.children}</span>
            <NewFieldButton onSave={props.create} />
        </Container>
    </SectionHeader>
)

const DeleteObjectButton = props => (
    <ButtonModal
        dialog
        label="Delete"
        footer={({ close }) => [
            <Button key="delete" sideMargin="xsmall" color="danger" onClick={close}>
                Delete
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
        footerClassName={css`
            justify-content: flex-end;
        `}
        header={() => `Really delete ${props.name}?`}
    >
        {() => <Text size="fontL">Doing so will remove all data in this table.</Text>}
    </ButtonModal>
)

const HeaderBar = props => (
    <Container>
        <Section maxSize={1} margin="none" padding="none">
            <Breadcrumbs crumbs={props.crumbs} />
            <PageTitle>{props.label}</PageTitle>
        </Section>
        <Container>{props.buttons}</Container>
    </Container>
)



// WEBPACK FOOTER //
// ./src/features/studio/containers/ObjectDetailPage.js